import React, {Component} from 'react';
import {renderWithNamespace, renderResourceTitle} from '../utils/Functions'

class Property extends Component {
	constructor(props) {
		super(props);

		let propsValues = []
		props.pJson.forEach((property) => {
			propsValues.push(property.o);
		})

		this.state = {
			propertyIRI: props.pJson[0].p,
			propertyValues: propsValues,
			propertyValuesRendered: [],
		}
		// console.log(this.state);
	}


	componentDidMount() {


		let pTemp = this.state.propertyValuesRendered
		if (this.state.propertyValues.length <= 50) {
			this.state.propertyValues.forEach((property) => {
				if (property.type === "uri") {

					renderResourceTitle(property.value).then(res => {
						let pTemp = this.state.propertyValuesRendered
						pTemp.push(res)
						this.setState({propertyValuesRendered: pTemp})
					});

				} else {
					return (
						pTemp.push(<div className="">
							{property.value}
						</div>)
					)

				}
			})

		}else{
			console.log("more then 50")

		}
		this.setState({propertyValuesRendered: pTemp})
	}


	render() {
		return (
			<tr>
				<td><label className="">
					<a data-label="" data-comment="" href={this.state.propertyIRI.value}>
						{/*void:<span>vocabulary</span>*/}
						{renderWithNamespace(this.state.propertyIRI.value)}
					</a></label></td>
				<td style={{width:"100%"}}>
					<>{this.state.propertyValues.length > 50 ? "count: "+ this.state.propertyValues.length : ""}</>
					<div className="c2 value"
					     style={{"marginTop": "0px", "visibility": "visible"}}>

						{this.state.propertyValuesRendered.map((property) => {
							return property
						})}
					</div>
				</td>
			</tr>
		);
	}
}

export default Property;